import React, { useState, useEffect, useContext, useRef } from "react";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { useHistory } from "react-router-dom";
import axios from "axios";
import logOut from "../Images/Logout Icon.svg";
import logIn from "../Images/logIn.svg";
import loginLogo from "../Images/Login logo.svg";
import supportIcon from "../Images/Support Icon.svg";
import mydashboard_logo_purple from "../Images/mydashbaord_logo_purple.png";
import profileImg from "../Images/profileImg.png";
import AuthContext from "../Context/auth/AuthContext";
import { Stack } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faSignInAlt, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { VelocityButton } from "./VelocityButton";
const NavBar = () => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const { isAuthenticated, user, searchFor, search } = authContext;
  // const [userInfo, setUserInfo] = useState(null);
  const [searchShow, setSearchShow] = useState(false);
  // const isAuthenticated = localStorage.getItem("isAuthenticated")
  //   ? localStorage.getItem("isAuthenticated")
  //   : null;
  const [popoverShow, setPopoverShow] = useState(true);
  // useEffect(() => {
  //   console.log("USER isAuthenticated", isAuthenticated);
  // }, [isAuthenticated]);
  // const { isAuthenticated, user, login, logout } = authContext;
  // console.log("USER NAV", user);
  useEffect(() => {
    // console.log("USER NAV UPDATED", user);
    if (user) {
      // setUserInfo(user);
      // console.log("USER NAV INFO UPDATED", user);
    }
  }, [user]);
  // useEffect(() => {
  //   const config = {
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   };
  //   if (!user) {
  //     try {
  //       axios.get("/user-detail", config).then((response) => {
  //         console.log("USER", response);
  //         setUser(response.data);
  //       });
  //     } catch (err) {
  //       console.log("Error", err);
  //     }
  //   }
  // }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios.get("/logout", config).then((response) => {
      // console.log("APPS", response);
      history.push("/");
    });
    localStorage.removeItem("isAuthenticated");
    // logout();
  };

  const searchRef = useRef();
  
  const handleSearchToggle = () => {
    setSearchShow(!searchShow);
    // Auto-focus the search input when opened
    if (!searchShow) {
      setTimeout(() => {
        if (searchRef.current) {
          searchRef.current.focus();
        }
      }, 100);
    }
  };
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        searchShow &&
        searchRef.current &&
        !searchRef.current.contains(e.target)
      ) {
        setSearchShow(false);
      }
    };

    document.addEventListener("click", checkIfClickedOutside);

    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [searchShow]);

  // console.log("SHOw", searchShow);

  const handleLogin = (e) => {
    e.preventDefault();
    window.location.href = "/login";
    // const config = {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // };
    // axios.get("/logout", config).then((response) => {
    //   console.log("APPS", response);
    //   history.push("/");
    // });
    // login();
  };

  const onSearch = (e) => {
    searchFor(e.target.value);
  };
  const supportEmail = "mailto:Jsi-Velocity_support@jsitel.com";
  const onClearSearch = () => {
    // console.log("clear");
    searchFor("");
  };
  const buttonStyle = {
    backgroundColor: "hsla(0,0%,100%,.2)",
    color: "#fff",
    fontSize: "small",
    width: "100px",
  };

  return (
    <Navbar className='nav-bar'>
      <div className='nav-bar__container'>
        <div className='nav-bar__logo'>
          <div className='nav-bar__logo__img'>
            <img
              src={mydashboard_logo_purple}
              alt='Logo'
              style={{ 
                width: "auto", 
                background: "transparent",
                objectFit: "contain"
              }}
            />{" "}
          </div>
        </div>
        <div className='nav-bar__menu'>
          {user && isAuthenticated ? (
            <NavDropdown
              id='nav-dropdown'
              className='nav-bar__menu__dropdown2'
              title={
                <div className='nav-bar__menu__dropdown2__toggle'>
                  <div className='nav-bar__menu__dropdown2__toggle__img'>
                    {`${user.firstname.charAt(0)} ${user.lastname.charAt(0)}`}
                  </div>
                  <div>
                    <div>{`${user.firstname} ${user.lastname}`}</div>
                    <div className='nav-bar__menu__dropdown2__toggle__sub-title'>
                      {user.company}
                    </div>
                  </div>
                  <div className='nav-bar__menu__dropdown2__icon'></div>
                </div>
              }
            >
              <NavDropdown.Item
                href='https://login.jsiportal.com/profile2'
                target='-blank'
              >
                My Account
              </NavDropdown.Item>
            </NavDropdown>
          ) : (
            popoverShow && (
              <>
                <div className='nav-bar__popover'>
                  <h5 className='nav-bar__menu__text__title'>
                    Please login to access all the applications
                  </h5>
                </div>
                <div className='nav-bar__animated-arrow'>
                  <span className='arrow'>&gt;</span>
                  <span className='arrow'>&gt;</span>
                  <span className='arrow'>&gt;</span>
                </div>
              </>
            )
          )}
          <div>
            <Stack direction='horizontal'>
              <div>
                {user ? (
                  <VelocityButton
                    variant="secondary"
                    href='/logout'
                  >
                    <img 
                      src={logOut} 
                      alt="Logout" 
                      style={{ 
                        width: "16px", 
                        height: "16px", 
                        marginRight: "5px"
                      }} 
                    />
                    LOGOUT
                  </VelocityButton>
                ) : (
                  <VelocityButton
                    variant="primary"
                    href='/login'
                    onMouseEnter={() => setPopoverShow(false)}
                    onMouseLeave={() => setPopoverShow(true)}
                  >
                    <img 
                      src={loginLogo} 
                      alt="Login" 
                      style={{ 
                        width: "16px", 
                        height: "16px", 
                        marginRight: "5px"
                      }} 
                    />
                    LOGIN
                  </VelocityButton>
                )}
              </div>
              <VelocityButton
                variant="tertiary"
                href={supportEmail}
              >
                <img 
                  src={supportIcon} 
                  alt="Support" 
                  style={{ 
                    width: "16px", 
                    height: "16px", 
                    marginRight: "5px"
                  }} 
                />
                SUPPORT
              </VelocityButton>
            </Stack>
          </div>

          <FontAwesomeIcon
            icon={faSearch}
            className='nav-bar__menu__search__icon'
            onClick={handleSearchToggle}
          />
          {searchShow && (
            <div className='nav-bar__menu__search__dropdown'>
              <FontAwesomeIcon icon={faSearch} className='nav-bar__menu__search__dropdown__icon' />
              <input
                ref={searchRef}
                type='text'
                value={search}
                placeholder='Search'
                className='nav-bar__menu__search__dropdown__input'
                onChange={(e) => onSearch(e)}
              />
              {search && (
                <FontAwesomeIcon
                  icon={faTimes}
                  className='nav-bar__menu__search__dropdown__clear'
                  onClick={() => onClearSearch()}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </Navbar>
  );
};

export default NavBar;
